var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s((_vm.dayString + "天" + _vm.hourString + "小时" + _vm.minuteString + "分" + _vm.secondString + "秒 ")))])}
var staticRenderFns = []

export { render, staticRenderFns }